import React from "react";

const SuccessPage = ({ receiptLink, onClose }) => {
  return (
    <div
      className="modal"
      style={{
        width: "90%",
        minWidth: "300px",
        maxWidth: "800px",
        margin: "0 auto",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <button
        className="close"
        onClick={onClose}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "-10px",
          top: "-10px",
          width: "36px",
          height: "36px",
          fontSize: "24px",
          background: "#D11A2A",
          borderRadius: "18px",
          border: "1px solid #cfcece",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          lineHeight: "normal",
          padding: 0,
        }}
      >
        ×
      </button>
      <img
        className="logo"
        src={"/img/raidhut.png"}
        alt="raidhut-logo"
        //style={{ maxWidth: "120px", height: "auto" }} // Reduzido um pouco
      />
      <h1
        className="modal-title"
        style={{
          fontSize: "clamp(1.3rem, 3vw, 1.8rem)", // Reduzido para mais proporcional
          margin: "20px 0",
          fontWeight: "600",
        }}
      >
        Pagamento Concluído
      </h1>

      <div style={{ margin: "20px 0", textAlign: "center" }}>
        <div
          style={{
            background: "#f0fff0",
            padding: "15px",
            borderRadius: "8px",
            border: "1px solid #a0d9a0",
            marginBottom: "20px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28" // Reduzido um pouco
            height="28"
            viewBox="0 0 24 24"
            style={{ marginBottom: "10px" }}
          >
            <circle cx="12" cy="12" r="10" fill="#4CAF50" />
            <path
              d="M9 16.2L5.5 12.7 4.1 14.1 9 19 21 7 19.6 5.6z"
              fill="white"
            />
          </svg>
          <h2
            style={{
              color: "#388e3c",
              margin: "10px 0",
              fontSize: "clamp(1.1rem, 2.5vw, 1.4rem)", // Ajustado para melhor proporção
              fontWeight: "500",
            }}
          >
            Pagamento aprovado!
          </h2>
          <p
            style={{
              fontSize: "clamp(0.9rem, 2vw, 1rem)", // Ajustado para melhor proporção
              color: "#555",
            }}
          >
            Os dados do pagamento foram enviados para o seu email
          </p>
        </div>

        {/* <div
          style={{
            width: "100%",
            minWidth: "280px",
            maxWidth: "700px",
            height: "100%",
            paddingBottom: "65%",
            position: "relative",
            overflow: "hidden",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "15px",
            display: receiptLink ? "block" : "none",
            border: "1px solid #ddd",
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Adicionada sombra sutil
          }}
        >
          <iframe
            src={receiptLink}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
              minHeight: "300px",
            }}
            title="Comprovante de pagamento"
          />
        </div> */}

        <button
          className="copy-button"
          onClick={onClose}
          style={{
            width: "100%",
            maxWidth: "400px",
            marginTop: "20px",
            marginLeft: "auto",
            marginRight: "auto",
            padding: "12px",
            fontSize: "0.95rem", // Tamanho fixo mais adequado
            display: "block",
          }}
        >
          Voltar para a loja
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;
